
jQuery(document).ready(function($) {

$('.about-artist .read-more').on('click', function(){
      $(this).hide();
      $(this).parent().find('.artist-excerpt').hide();
      $(this).parent().find('.read-less').show();
      $(this).parent().find('.artist-full-content').show();
    });

    $('.about-artist .read-less').on('click', function(){
      $(this).hide();
      $(this).parent().find('.artist-excerpt').show();
      $(this).parent().find('.read-more').show();
      $(this).parent().find('.artist-full-content').hide();
    });
});